module.exports = __webpack_public_path__ + "static/media/toasterrorSound.ffb86c68.mp3";